import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m-5 2.66c-2.285 0 -3.915 2.619 -3.997 5.752l-.003 .248c0 3.242 1.655 6 4 6s4 -2.758 4 -6s-1.655 -6 -4 -6","key":"svg-0"}]]

const IconBrandOperaFilled = createReactComponent('filled', 'brand-opera-filled', 'BrandOperaFilled', __iconNode);

export default IconBrandOperaFilled;